import app from './app.json';
import common from './common.json';
import page from './page.json';
const zhTW = {
    app,
    common,
    page
};
export default zhTW;
